import React from 'react';
import Moment from 'react-moment';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';

const styles = () => ({
  root: {
    margin: '10px 0',
  },
  content: {
    border: '1px solid #dbdbdb',
    padding: '20px',
  },
  textRight: {
    textAlign: 'right',
  },
});

class AnnouncementComment extends React.Component {
  render() {
    const {
      classes,
      t,
      data,
      onDeleteLinkClick,
      onEditLinkClick,
    } = this.props;

    return (
      <div className={`announcement-comments ${classes.root}`}>
        <div className={classes.content}>{data.text}</div>
        <Grid container className={classes.footer}>
          <Grid item xs={6}>
            {data.parent_name && (
              <small>{data.parent_name} - </small>
            )}
            <small><Moment format={dateFormat + ' HH:mm'}>{data.date}</Moment></small>
          </Grid>
          <Grid item xs={6} className={classes.textRight}>
            {data.can_edit && (
              <>
                <a href="#" onClick={onDeleteLinkClick}>{t('Delete')}</a>
                <span> | </span>
                <a href="#" onClick={onEditLinkClick}>{t('Edit')}</a>
              </>
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(withSnackbar(withTranslation()(AnnouncementComment)));
